'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isKeyframesTarget = require('../animation/utils/is-keyframes-target.js');

var isCustomValue = function (v) {
  return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function (v) {
  // TODO maybe throw if v.length - 1 is placeholder token?
  return isKeyframesTarget.isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

exports.isCustomValue = isCustomValue;
exports.resolveFinalValueInKeyframes = resolveFinalValueInKeyframes;
